import React from "react";
import Icon from "storybookComponents/Icon.js";
import Popover from '@material-ui/core/Popover';
import { withStyles } from "@material-ui/core";
import Item from "./item";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import styles from "./style";
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import remove_notification from "./removeNotification"
import notifLoader from './LoadNotif';
import { getPropertyId } from "common/index";
import { emitCustomEvent } from 'react-custom-events';
import IconButton from '@material-ui/core/IconButton';


try {
  TimeAgo.addDefaultLocale(en)
}
catch (err) { }

var previous = []

const Notifications = ({ environment, classes, orgLevel, scope, pool }) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [show_close_notification, set] = React.useState(null);

  const [tasks, setTasks] = React.useState([]);
  const [contextId, setContextId] = React.useState()

  React.useEffect(() => {
    init();
    let interval = pool ? setInterval(init, 5000) : null;
    return () => {
      if (pool)
        clearInterval(interval)
    }
  }, [scope])

  const init = async () => {
    try {
      let resp = await notifLoader(getPropertyId(), scope);
      let newNotifs = [];
      if (resp.notifications && resp.notifications.notifications) {
        setContextId(resp.notifications.id)
        for (let i = 0; i < resp.notifications.notifications.length; i++) {
          let id = resp.notifications.notifications[i].id;
          let old = previous.find(notif => notif.id === id);
          if (!old)
            newNotifs.push(resp.notifications.notifications[i]);
        }
        previous = resp.notifications.notifications;
        setTasks(resp.notifications.notifications);
      }
      if (newNotifs.length)
        emitCustomEvent('agentNotif', newNotifs);
    }
    catch (err) {
      console.log("notifications err : ", err)
    }

  }

  const mouseOver = (id) => id && set(id);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onNotificationClick = (event, propertyId, notification) => {
    if (window.location.pathname.startsWith("/" + propertyId + "/event")) {
      return window.location.replace(`/${propertyId}/event/${notification.sourceId}`)
    }
    window.open(
      `${propertyId}/event/${notification.sourceId}`,
      "_blank"
    );
  }

  const remove_notification_item = (id, status, context_id) => {
    remove_notification(
      environment,
      {
        id,
        scope,
        clientMutationId: id
      },
      context_id
    );
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const counts = tasks.length;



  return (
    <>
      <IconButton className={classes.container} onClick={handleClick}>
        <NotificationIcon />
        {
          counts ? <p className={classes.badge} onClick={handleClick}>{counts}</p> : null
        }
      </IconButton>


      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{
          paper: classes.paperClass,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className={orgLevel ? classes.bodyContainerorg : classes.bodyContainer}>
          <div className={classes.arrow} />
          <Card className={classes.root}>
            <CardHeader
              subheader={`Alerts (${tasks.length})`}
              classes={{
                root: classes.cardHeader,
                subheader: classes.subheader,
                action: classes.action_volume,
              }}
            />

            <CardContent className={classes.card_content + " " + classes.withoutPadding}>
              <div className={classes.popoverBody}>
                {tasks.map((notification) =>
                  <Item key={notification.id}
                    notification={notification}
                    mouseOver={mouseOver}
                    show_close_notification={show_close_notification}
                    handleClose={remove_notification_item}
                    handleClick={onNotificationClick}
                    context_id={contextId}
                  />)}
              </div>
            </CardContent>
          </Card>
        </div>
      </Popover>

    </>
  )



}

const NotificationIcon = ({ stroke, fill }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.6667 12V8.66667C16.6667 7.42899 16.175 6.242 15.2998 5.36684C14.4247 4.49167 13.2377 4 12 4C10.7623 4 9.57534 4.49167 8.70017 5.36684C7.825 6.242 7.33333 7.42899 7.33333 8.66667V12C7.3135 13.6467 6.85312 15.2581 6 16.6667H18C17.1469 15.2581 16.6865 13.6467 16.6667 12Z'
      stroke='#333333'
      strokeMiterLimit='10'
      strokeLinecap='square'
    />
    <path
      d='M10.1104 17.9995C10.2489 18.3883 10.5043 18.7248 10.8416 18.9627C11.1789 19.2006 11.5816 19.3283 11.9944 19.3283C12.4071 19.3283 12.8098 19.2006 13.1471 18.9627C13.4844 18.7248 13.7398 18.3883 13.8784 17.9995H10.1104Z'
      fill='#333333'
    />
  </svg>
);

export default withStyles(styles)(Notifications);































